<template>
    <div>
        <v-snackbar
            v-model="showToast"
            color="green lighten-1"
            text
            top
            right
            rounded
            style="margin-top: 75px;"
        >
            {{ toastMsg }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="green lighten-1"
                    text
                    v-bind="attrs"
                    @click="showToast = false"
                >
                    <v-icon color="green lighten-1">
                        close
                    </v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <div
            v-if="!loading"
            class="tie-breaking"
        >
            <h3 class="pb-2">
                Auto-Assign Tie Breaking
            </h3>
            <span class="description">When Auto-Assigning tickets to Locators and there is a Tie between 2 or more Locators, the system will break the tie by one of two methods:</span>
            <v-radio-group
                v-model="method"
                class="mt-0"
            >
                <v-radio value="LEAST-TICKETS">
                    <template v-slot:label>
                        <div class="mt-5">
                            <h4>Least tickets</h4>
                            <span class="radio-description">The locator with the least number of currently assigned tickets will win.</span>
                        </div>
                    </template>
                </v-radio>
                <v-radio value="MAX-AREA">
                    <template v-slot:label>
                        <div :class="{'mt-5' : !$vuetify.breakpoint.sm && !$vuetify.breakpoint.md, 'mt-10' : $vuetify.breakpoint.sm || $vuetify.breakpoint.md}">
                            <h4>Maximum Intersection Area</h4>
                            <span class="radio-description">The locator with the most Intersection Area between the Map Layer(s) and the Ticket Digsite polygon. If no winner, falls back to Least Tickets.</span>
                        </div>
                    </template>
                </v-radio>
            </v-radio-group>
            <v-btn
                class="px-0"
                style="text-transform: none !important"
                depressed
                color="primary"
                @click="updateTieBreaking"
            >
                Apply
            </v-btn>
        </div>
        <div
            v-if="loading"
            class="d-flex justify-center align-center w-100p"
            style="height: 70vh;"
        >
            <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
            />
        </div>
    </div>
</template>

<script>

import webtmsBackend from '@/services/webtmsBackend';
import { getCompanyOption } from '@/utils/options';

export default {
    name: 'AutoAssignTieBreaking',
    data() {
        return {
            method: '',
            showToast: false,
            toastMsg: '',
            loading: false
        };
    },
    computed: {
        tieBreakingMethod() {
            return getCompanyOption('AUTOASSIGN_TIEBREAK_METHOD');
        }
    },
    mounted() {
        this.method = this.tieBreakingMethod;
    },
    methods: {
        async updateTieBreaking() {
            this.loading = true;
            let response = await webtmsBackend.updateTieBreaking(this.method);
            if(response.set.length > 0 && response.set[0][0] === 'AUTOASSIGN_TIEBREAK_METHOD' && response.set[0][1] === this.method) {
                let companyOptions = this.$store.getters.companyOptions;
                let index = companyOptions.findIndex(item => item.option === 'AUTOASSIGN_TIEBREAK_METHOD');
                companyOptions[index].value = this.method;
                this.$store.commit('SET_COMPANY_OPTIONS', companyOptions);
                this.loading = false;
                this.showToast = true;
                this.toastMsg = 'Tie Breaking method updated successfully.';
            }
        }
    }
};
</script>

<style>
	.tie-breaking {
		color: 35383F;
	}
	.tie-breaking .description {
		font-size: 12px;
	}
	.tie-breaking .radio-description {
		font-size: 12px;
	}
</style>